<app-alert></app-alert>

<div class="dashboard dashboard-center otros-despachos-page">
  <div class="d-flex align-items-center flex-nowrap otros-despachos-toolbar mb-3">
    <div class="flex-shrink-0">
      <a (click)="updateUrl()" class="btn btn-primary button-actualizar">
        <i class="bi bi-arrow-clockwise me-2"></i>
        Actualizar
      </a>
    </div>
  </div>

  <div class="otros-dispatch-list" *ngIf="otherOrders.length > 0; else noOtherDispatches">
    <app-hormigon-dispatch-card
      *ngFor="let order of otherOrders"
      [order]="order"
      title="Despacho N°"
      [titleNumber]="order.orderNumber"
      [showAdditiveRemarks]="false"
      [showPreviousTruck]="false"
      [showOrderNumber]="false"
      (continue)="onContinue($event)"
      (paperGuide)="onPaperGuide($event)">
    </app-hormigon-dispatch-card>
  </div>

  <ng-template #noOtherDispatches>
    <p class="text-center text-muted mt-4">
      No hay despachos pendientes.
    </p>
  </ng-template>
</div>
